import React, { useRef } from 'react';
import { FaFilePdf, FaImage, FaUpload } from 'react-icons/fa';
import { BASE_URL } from '../../../constants/configConstants';
import './DocumentUpload.css';

const DocumentUpload = ({ 
  label, 
  required = false, 
  error, 
  onChange, 
  value, 
  disabled = false,
  accept = '.jpg,.jpeg,.png',
  // accept = '.pdf,.jpg,.jpeg,.png',
  uploadedDoc = null,
  placeholder = 'Select Document'
}) => {
  const fileInputRef = useRef(null);

  const isImage = (file) => {
    return file && file.type && file.type.startsWith('image/');
  };

  const isPDF = (file) => {
    return file && file.type === 'application/pdf';
  };

  const isImagePath = (filePath) => {
    if (!filePath) return false;
    const cleanPath = filePath.split('?')[0];
    return /\.(jpg|jpeg|png)$/i.test(cleanPath);
  };

  const isPDFPath = (filePath) => {
    if (!filePath) return false;
    const cleanPath = filePath.split('?')[0];
    return /\.pdf$/i.test(cleanPath);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      onChange(file);
    }
  };

  const handleClick = () => {
    if (!disabled) {
      fileInputRef.current.click();
    }
  };

  const getFileIcon = () => {
    if (value) {
      if (isImage(value)) {
        return <FaImage className="document-upload-file-icon" />;
      } else if (isPDF(value)) {
        return <FaFilePdf className="document-upload-file-icon" />;
      }
    }
    return <FaUpload className="document-upload-file-icon" />;
  };

  const getDisplayText = () => {
    if (value) {
      return value.name || 'Document selected';
    }
    return placeholder;
  };

  const renderContent = () => {
    // Show preview for newly picked document
    if (value?.uri || value) {
      if (isImage(value)) {
        return (
          <img 
            src={value.uri || URL.createObjectURL(value)} 
            alt="Preview" 
            className="document-upload-preview" 
          />
        );
      } else if (isPDF(value)) {
        return (
          <div className="document-upload-content">
            <FaFilePdf className="document-upload-file-icon" />
            <span className="document-upload-placeholder-text">
              {value.name || 'Document selected'}
            </span>
          </div>
        );
      }
    }
    
    // Show uploaded document if present
    if (uploadedDoc) {
      if (isImagePath(uploadedDoc)) {
        return (
          <img 
            src={`${BASE_URL}/${uploadedDoc}`} 
            alt="Uploaded document" 
            className="document-upload-preview" 
          />
        );
      } else if (isPDFPath(uploadedDoc)) {
        return (
          <div className="document-upload-content">
            <FaFilePdf className="document-upload-file-icon" />
            <span className="document-upload-placeholder-text">
              {uploadedDoc.split('/').pop().split('?')[0]}
            </span>
          </div>
        );
      }
    }
    
    // Default placeholder
    return (
      <div className="document-upload-content">
        <FaUpload className="document-upload-file-icon" />
        <span className="document-upload-placeholder-text">{placeholder}</span>
      </div>
    );
  };

  return (
    <div className="document-upload-container">
      {label && (
        <label className="document-upload-label">
          {label}
          {required && <span className="document-upload-required-text">*</span>}
        </label>
      )}
      
      <div 
        className={`document-upload-area ${disabled ? 'disabled' : ''}`}
        onClick={handleClick}
      >
        <input
          ref={fileInputRef}
          type="file"
          accept={accept}
          onChange={handleFileChange}
          className="document-upload-file-input"
          disabled={disabled}
        />
        
        {renderContent()}
      </div>
      
      {error && <div className="document-upload-error-text">{error}</div>}
    </div>
  );
};

export default DocumentUpload; 